import React from 'react';
import DashboardGrid from '../features/dashboard/DashboardGrid';

const MemberDashboard = () => <DashboardGrid kind="member" />;

export default MemberDashboard;
